import script from "./WorldDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./WorldDetail.vue?vue&type=script&setup=true&lang=js"

import "./WorldDetail.vue?vue&type=style&index=0&id=479f6fa7&lang=stylus&scoped=true"

import exportComponent from "/Users/wuhelong/Documents/文稿/project_two/华都官网/huadu/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-479f6fa7"]])

export default __exports__